
import { AdminState } from '@/types/adminTypes';
import { createDefaultState } from './adminStateConfig';

/**
 * Map database record (snake_case) to application state (camelCase)
 */
export const mapDbRecordToState = (data: any): AdminState => {
  if (!data) {
    return createDefaultState();
  }
  
  return {
    lastActivity: data.last_activity || new Date().toISOString(),
    activeAdmins: data.active_admins || [],
    lastSync: data.last_sync || new Date().toISOString()
  };
};

/**
 * Map application state (camelCase) to database record (snake_case)
 */
export const mapStateToDbRecord = (state: AdminState, id: number = 1): any => {
  return {
    id,
    last_activity: state.lastActivity,
    active_admins: state.activeAdmins,
    last_sync: state.lastSync
  };
};

/**
 * Map partial state updates to database format for upsert
 */
export const mapUpdatesToDbRecord = (
  updates: Partial<AdminState>, 
  currentState: AdminState, 
  id: number = 1
): any => {
  return {
    id,
    last_activity: updates.lastActivity || currentState.lastActivity,
    active_admins: updates.activeAdmins || currentState.activeAdmins,
    last_sync: updates.lastSync || currentState.lastSync
  };
};
